<!-- section template -->
<template>
  <div ref="sticky" :class="$style.baseSticky" :style="stickyStyle">
    <div class="baseSticky__fixTop" :style="fixTopStyle"></div>
    <div ref="content" class="baseSticky__content" :style="contentStyle">
      <slot />
    </div>
  </div>
</template>

<script>
import { elementGetOffsetTop } from '@utils/element'

export default {
  props: {
    offset: {
      type: Number,
      default: 0,
    },
    menuHeight: {
      type: Number,
      default: 90,
    },
    spaceTop: {
      type: Number,
      default: 106,
    },
    spaceBottom: {
      type: Number,
      default: 40,
    },
  },
  data() {
    return {
      fixTop: 0,
      windowHeight: 0,
      contentHeight: 0,
      contentOverBottom: 0,
      contentOverTop: 0,
      stickyHeight: 0,
      stickyMin: 0,
      stickyResizeObserver: null,
      bannerHeight: 0,
    }
  },
  computed: {
    stickyStyle() {
      return `--stickyOffset: ${this.offset}px;`
    },
    fixTopStyle() {
      if (this.contentHeight > this.stickyMin) {
        return {
          marginTop: `${this.fixTop || 0}px`,
        }
      } else {
        return {
          marginTop: 0,
        }
      }
    },
    contentStyle() {
      if (this.contentHeight > this.stickyMin) {
        if (this.$globalDirection === 'up') {
          return {
            bottom: `${this.contentOverBottom}px`,
          }
        } else {
          return {
            top: `${this.contentOverTop}px`,
          }
        }
      } else {
        return {
          top: `${this.menuHeight + this.spaceTop}px`,
        }
      }
    },
  },
  watch: {
    $globalDirection(value) {
      if (value === 'up') {
        const fixDistanceUp = this.contentOverTop - this.$refs['content'].getBoundingClientRect().top - (this.spaceTop - this.spaceBottom)

        this.fixTop = this.$globalScrollTop + (this.contentOverBottom - this.bannerHeight) - fixDistanceUp - this.offset
      } else {
        const fixDistanceDown = -this.contentOverBottom - (this.$refs['content'].getBoundingClientRect().bottom - window.innerHeight)

        this.fixTop = this.$globalScrollTop - (this.bannerHeight - this.spaceTop) - fixDistanceDown - this.offset
      }

      if (this.fixTop < 0) {
        this.fixTop = 0
      }

      if (this.fixTop > this.stickyHeight - this.contentHeight) {
        this.fixTop = this.stickyHeight - this.contentHeight
      }
    },
  },
  mounted() {
    const initStickyResizeObserver = () => {
      this.stickyResizeObserver = new ResizeObserver((entries) => {
        this.setData()
      })

      this.stickyResizeObserver.observe(this.$refs['sticky'])
    }

    const initResizeListener = () => {
      window.addEventListener('resize', this.setData)
    }

    initStickyResizeObserver()
    initResizeListener()
    setTimeout(() => {
      this.setData()
    }, 1200)
  },
  destroyed() {
    const removeStickyResizeObserver = () => {
      this.stickyResizeObserver.disconnect()
    }

    const removeResizeListener = () => {
      window.removeEventListener('resize', this.setData)
    }

    removeResizeListener()
    removeStickyResizeObserver()
  },
  methods: {
    setData() {
      // this.bannerHeight = elementGetOffsetTop(this.$refs['sticky'].$el) + this.menuHeight;
      this.bannerHeight = elementGetOffsetTop(this.$refs['sticky']) + this.menuHeight
      this.windowHeight = window.innerHeight
      this.contentHeight = this.$refs['content'].offsetHeight
      this.stickyHeight = this.$refs['sticky'].offsetHeight
      this.contentOverBottom = this.windowHeight - this.contentHeight - this.spaceTop - this.menuHeight
      this.contentOverTop = this.windowHeight - this.contentHeight - this.spaceBottom
      this.stickyMin = window.innerHeight - this.menuHeight - (this.spaceTop + this.spaceBottom)
    },
  },
}
</script>

<!-- section style -->
<style lang="scss" module>
.baseSticky {
  display: flex;
  flex-direction: column;
  height: 100%;
  margin-top: var(--stickyOffset);

  :global {
    .baseSticky {
      &__fixTop {
        @include unstyled;
      }

      &__content {
        position: sticky;
      }
    }
  }
}
</style>
